import {
  mobileNavItems,
  sideBarConstantsDesigner,
} from "shared/utils/constants";
import { routeConstant } from "shared/routes/routeConstant";
import DashboardWrapper from "../../dashboardCommon/dashboardWrapper";

interface Props {
  children: any;
}

function DesignerWrapper({ children }: Props) {
  const mainPages = [
    routeConstant.designer.home.path,
    routeConstant.designer.allProjects.path,
    routeConstant.designer.notifications.path,
    routeConstant.designer.accountSetting.path,
  ];

  return (
    <DashboardWrapper
      sidebarArr={sideBarConstantsDesigner}
      mobileNavItems={mobileNavItems}
      mainPages={mainPages}
      userType="designer"
      showMobileNavConditionally={true}
    >
      {children}
    </DashboardWrapper>
  );
}

export default DesignerWrapper;
